/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from 'react';
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    TimeScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    Title,
    defaults,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import Annotation from 'chartjs-plugin-annotation';
import { LoadingDots } from '@app/ui';
import addCanvasBackground from './addCanvasBackground';

defaults.font.family = 'aspiralight, pnlight';
ChartJS.register(
    LinearScale,
    CategoryScale,
    TimeScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    Title,
    addCanvasBackground,
    Annotation,
);

import * as R from 'ramda';

// Graph Config section
import baseConfig from '../../utils/charts/base-config';
import { appendColor } from '../../utils/charts/base-point-config';
import mergeConfigs from '../../utils/charts/merge-configs';

import currencyY from '../../utils/charts/currency-y-axis-config';
import secY from '../../utils/charts/sec-y-axis-config';
import dateY from '../../utils/charts/date-y-axis-config';
import decimalY from '../../utils/charts/decimal-y-axis-config';
import percentageY from '../../utils/charts/percentage-y-axis-config';

import categoryX from '../../utils/charts/category-x-axis-config';
import currencyX from '../../utils/charts/currency-x-axis-config';
import dateX from '../../utils/charts/date-x-axis-config';

const yAxisConfigs = {
    currency: currencyY,
    percentage: percentageY,
    decimal: decimalY,
    date: dateY,
    sec: secY,
};

const xAxisConfigs = {
    currency: currencyX,
    date: dateX,
    category: categoryX,
};

const strategy = (key, left, right) => {
    if (key === 'xAxes' || key === 'yAxes') {
        return [R.mergeDeepRight(left[0], right[0])];
    }
    return right;
};

type PointChartProps = {
    isLoading?: boolean;
    data: {
        datasets: {
            data: Array<string | number | any>;
        }[];
        labels: Array<string | number>;
    };
    options?: {
        currency?: string;
        xType?: string;
        yType?: string;
        title?: string;
        config?: any;
        locale?: string;
    };
};

const PointChart = React.forwardRef<any, PointChartProps>(
    ({ data, isLoading, options = {} }, ref) => {
        // eslint-disable-next-line no-unused-vars
        const {
            currency = 'USD',
            xType,
            yType,
            title,
            config = {},
            locale,
        } = options;

        const chartConfig = mergeConfigs(
            strategy,
            baseConfig,
            xAxisConfigs[xType]({ currency, locale }),
            yAxisConfigs[yType]({ currency, locale }),
            title ? { title: { text: title } } : {},
            config,
        );

        const parsedData = R.evolve({ datasets: appendColor }, data);

        return isLoading ? (
            <LoadingDots size="lg" />
        ) : (
            <Line ref={ref} data={parsedData} options={chartConfig} redraw />
        );
    },
);

export default PointChart;
